import { Injectable } from "@angular/core";
import { NetworkService } from "../../shared/network.service";

@Injectable({
  providedIn: "root",
})
export class OrderService {
  constructor(private networkservice: NetworkService) {}

  getPaymentApi(query: any) {
    return this.networkservice.get(
      "api/invoice?" + query,
      null,
      null,
      "bearer"
    );
  }
  getOrderApi(query: any) {
    return this.networkservice.get("api/order?" + query, null, null, "bearer");
  }
  getNewOrder(query: any) {
    return this.networkservice.get("api/order/unseenOrderCount?" + query, null, null, "bearer");
  }

  updateDriver(body: any) {
    return this.networkservice.put(
      "api/order/acceptReject?",
      body,
      null,
      "bearer"
    );
  }
  // updateOrder(user: any) {
  //   return this.networkService.put("api/vendor", user, null, "bearer");
  // }
  updateOrderApi(body: any) {
    return this.networkservice.put(
      "api/order/acceptReject?",
      body,
      null,
      "bearer"
    );
  }

  getOperatorList() {
    return this.networkservice.get("api/operator", null, null, "bearer");
  }
  createInvoice() {
    return this.networkservice.get(
      "api/invoice/generateDailyInvoice",
      null,
      null,
      "bearer"
    );
  }

  putPaymentApi(body: any) {
    return this.networkservice.put("api/payment", body, null, "bearer");
  }
  getRevanue() {
    return this.networkservice.get(
      "api/dashboard/invoice",
      null,
      null,
      "bearer"
    );
  }
  getPendingInvoice() {
    return this.networkservice.get(
      "api/dashboard/pendingInvoiceList",
      null,
      null,
      "bearer"
    );
  }
}
